import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import {
  ORIGINAL,
  SINGLE_PHOTO,
  VIDEO,
  CERTIFICATE,
  SOCIAL_MEDIA,
  VOUCHER,
  RESTART_PRODUCTION,
} from '../../../utils/variables';

import {
  Image,
  Mobile,
  Certificate,
  Video,
  Star,
  Restart,
  Receipt
} from '@carbon/icons-react';

import AccountDownloadTileZipDownload from './AccountDownloadTileZipDownload';
import AccountDownloadTileVideo from './AccountDownloadTileVideo';
import AccountDownloadTileVoucher from './AccountDownloadTileVoucher';
import AccountDownloadDialogTile from './AccountDownloadDialogTile';
import AccountRestartTile from './AccountRestartTile';
import AccountDownloadTileCertificate from './AccountDownloadTileCertificate';

const AccountDownloadTile = ({
  type,
  notActive,
  onScrollToMedia,
  values,
  eventSgId,
  isFaceSearchEvent,
  intl,
  areProcessed,
  isWrappedInLink,
  bibNumber,
  originalsAreAvailable,
  photoNodeId,
  startNumbers,
  isUserInputForCertificateRequired,
  isAdditionalConsentForCertificateRequired,
  certificateOrganizerUrl,
  isInThumbnailPreview,
}) => {
  switch (type) {
    case SINGLE_PHOTO:
      return (
        <AccountDownloadDialogTile
          icon={<Image className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="messages.singlePhoto"
              defaultMessage="Single Photo"
            />
          }
          type={type}
          onScrollToMedia={onScrollToMedia}
        />
      );
    case SOCIAL_MEDIA:
      return (
        <AccountDownloadTileZipDownload
          icon={<Mobile className="account-tile-icon" />}
          textInSpan={
            isInThumbnailPreview ? (
              <FormattedMessageWrappedInSpan
                defaultMessage="Social Media Resolution"
                id="messages.socialMediaRes"
              />
            ) : (
              <FormattedMessageWrappedInSpan
                id="accountEventPage.products.socialMediaRes"
                defaultMessage="Social Media Resolution (download all)"
              />
            )
          }
          type={type}
          eventSgId={eventSgId}
          isWrappedInLink={isWrappedInLink}
          bibNumber={bibNumber}
        />
      );
    case RESTART_PRODUCTION:
      return (
        <AccountRestartTile
          icon={<Restart className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.actions.requestHiRes"
              defaultMessage="Request High Resolution"
            />
          }
          type={type}
          eventSgId={eventSgId}
        />
      );
    case ORIGINAL:
      if (areProcessed) {
        return (
          <AccountDownloadDialogTile
            icon={<Star className="account-tile-icon" />}
            textInSpan={
              isInThumbnailPreview ? (
                <FormattedMessageWrappedInSpan
                  defaultMessage="High Resolution"
                  id="messages.highRes"
                />
              ) : (
                <FormattedMessageWrappedInSpan
                  id="accountEventPage.products.highRes"
                  defaultMessage="High Resolution (download all)"
                />
              )
            }
            type={type}
            notActive={true}
          />
        );
      } else
        return (
          <AccountDownloadTileZipDownload
            icon={<Star className="account-tile-icon" />}
            textInSpan={
               isInThumbnailPreview ? (
                <FormattedMessageWrappedInSpan
                  defaultMessage="High Resolution"
                  id="messages.highRes"
                />
              ) : (
              <FormattedMessageWrappedInSpan
                id="accountEventPage.products.highRes"
                defaultMessage="High Resolution (download all)"
              />)
            }
            type={type}
            eventSgId={eventSgId}
            isWrappedInLink={isWrappedInLink}
            bibNumber={bibNumber}
          />
        );
    case VIDEO:
      return (
        <AccountDownloadTileVideo
          icon={<Video className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.video"
              defaultMessage="Video"
            />
          }
          notActive={notActive}
          type={type}
          values={values}
          eventSgId={eventSgId}
          isFaceSearchEvent={isFaceSearchEvent}
          intl={intl}
        />
      );
    case CERTIFICATE:
      return (
        <AccountDownloadTileCertificate
          icon={<Certificate className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.certificate"
              defaultMessage="Certificate"
            />
          }
          type={CERTIFICATE}
          onScrollToMedia={onScrollToMedia}
          originalsAreAvailable={originalsAreAvailable}
          photoNodeId={photoNodeId}
          isFaceSearchEvent={isFaceSearchEvent}
          notActive={notActive}
          eventSgId={eventSgId}
          startNumbers={startNumbers}
          isUserInputForCertificateRequired={isUserInputForCertificateRequired}
          isAdditionalConsentForCertificateRequired={isAdditionalConsentForCertificateRequired}
          certificateOrganizerUrl={certificateOrganizerUrl}
        />
      );
    case VOUCHER:
      return (
        <AccountDownloadTileVoucher
          icon={<Receipt className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.voucher"
              defaultMessage="Voucher"
            />
          }
          values={values}
        />
      );
  }
};

AccountDownloadTile.defaultProps = {
  isInThumbnailPreview: false,
};

AccountDownloadTile.propTypes = {
  type: PropTypes.string,
  values: PropTypes.array,
  notActive: PropTypes.bool,
  onScrollToMedia: PropTypes.func,
  eventSgId: PropTypes.number,
  isFaceSearchEvent: PropTypes.bool,
  intl: PropTypes.object,
  onRequestHighResolutionPhoto: PropTypes.func,
  isWrappedInLink: PropTypes.bool,
  originalsAreAvailable: PropTypes.bool,
  bibNumber: PropTypes.string,
  startNumbers: PropTypes.array,
  isUserInputForCertificateRequired: PropTypes.bool,
  isAdditionalConsentForCertificateRequired: PropTypes.bool,
  certificateOrganizerUrl: PropTypes.string,
  isInThumbnailPreview: PropTypes.bool,
};

export default AccountDownloadTile;
